import WRAP from 'WRAP-JS'
import { configControlZoneDh, configControlZoneLayer } from './config/ConfigControlZone';
import { MAP_ID_CONTROL_ZONE } from "../../../store/MapContentsState";
import { COMMUNICATE_ERROR_MESSAGE_AERIAL_AIRPORT, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from '../../../constants/ErrorMessage';

class ControlZone {
  static NAME = MAP_ID_CONTROL_ZONE
  dh;
  layer;
  ready = false;
  contentsDispatcher;

  constructor() {
    this.layer = new WRAP.Geo.Layer(this.constructor.NAME);
    this.layer.setVisible(false);
    this.layer.setTooltip(this._toolTip);
  }

  async initialize() {
    await this.initData();
    this.initLayer();
    this.ready = true;
  }

  async initData() {
    return new Promise(resolve => {
      this.dh = new WRAP.Data(configControlZoneDh);
      this.dh.load('data', null, false, ref => {
        resolve(ref);
      }, _ => {
        this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_AERIAL_AIRPORT,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
      });
    });
  }

  initLayer() {
    this.layer.configure(this.dh, configControlZoneLayer);
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.ready) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this.layer;
  }

  getLegend() {
    return {
      id: ControlZone.NAME,
      label: 'Control zone'
    };
  }

  setVisible(visible) {
    if (!this.ready) return;

    if (this.layer.visible() === visible) {
      return;
    }

    if (visible) {
      this.layer.show();
    } else {
      this.layer.hide();
    }
  }

  changeRoutePointEditing(routePointEditing) {
    this.layer.disableInteraction(routePointEditing);
  }

  _toolTip(geo) {
    const prop = geo.properties;
    const tooltip = [`<ul><li>${prop.name}</li><li>${prop.height}</li></ul>`];
    tooltip.push(`<hr/><ul>`);
    ['TWR', 'APP', 'DEP', 'GND', 'ATIS', 'RADAR', 'airport_info']
      .map(key => prop[key])
      .filter(val => val !== null)
      .forEach(val => tooltip.push(`<li>${val}</li>`));
    tooltip.push(`</ul>`);
    return tooltip.join('');
  }

  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }
}

export default ControlZone;
